export default __webpack_public_path__ + "static/media/czarny_bez.b957262a.svg";